import React, { useEffect, useMemo, useState } from 'react';
// import { exportToCsv, exportToPdf } from './exportUtils';
import { Col, Container, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import { TreeDataGrid } from 'react-data-grid';
import DefaultCurrency from 'components/DefaultCurrency';
import PercentFormat from 'components/PercentFormat';

const AdvancedTable = ({
  tableData,
  setTableData,
  groupBy,
  setGroupBy,
  expandedGroupIds,
  setExpandedGroupIds,
  sortColumns,
  setSortColumns,
  AdditionalFilter,
  filters,
  setFilters
}) => {
  const [isExporting, setIsExporting] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [lazyLoadingData, setLazyLoadingData] = useState([]);
  const [hasNext, setHasNext] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSort = (rows, sortColumns) => {
    const sortedRows = [...rows].sort((a, b) => {
      for (const sort of sortColumns) {
        const { columnKey, direction } = sort;
        const aValue = a[columnKey];
        const bValue = b[columnKey];

        const getColumn = column => {
          if (column.type == 'group') {
            for (const col of column.children) {
              const c = getColumn(col);
              if (c) {
                return c;
              }
            }
          } else if (column.key == columnKey) {
            return column;
          } else return false;
        };
        let column = undefined;
        for (const col of tableData.columns) {
          column = getColumn(col);
          if (column) {
            break;
          }
        }

        let comparison = 0;

        if (column?.type == 'date') {
          const aDate = new Date(aValue);
          const bDate = new Date(bValue);
          comparison = aDate - bDate;
        } else if (column?.type == 'currency' || column?.type == 'percent') {
          // Handle date comparison
          const x = a[columnKey + 'Value'];
          const y = b[columnKey + 'Value'];
          comparison = x - y;
        } else if (column?.type == 'text') {
          comparison = aValue?.localeCompare(bValue);
        } else if (column?.type == 'number') {
          comparison = aValue - bValue;
        } else if (column?.type == 'list-text') {
          comparison = a[columnKey + 'Value']?.[0]?.localeCompare(
            b[columnKey + 'Value']?.[0]
          );
        } else if (column?.type == 'date_and_time') {
          // Parse the date strings properly for comparison
          try {
            const aDate = new Date(a[columnKey + 'Value'] || '');
            const bDate = new Date(b[columnKey + 'Value'] || '');

            // Check if dates are valid
            if (isNaN(aDate.getTime()) || isNaN(bDate.getTime())) {
              // Fallback to string comparison if date parsing fails
              comparison = String(a[columnKey + 'Value'] || '').localeCompare(
                String(b[columnKey + 'Value'] || '')
              );
            } else {
              comparison = aDate - bDate;
            }
          } catch (error) {
            // Fallback to string comparison if date parsing throws an error
            comparison = String(a[columnKey + 'Value'] || '').localeCompare(
              String(b[columnKey + 'Value'] || '')
            );
          }
        }

        if (comparison !== 0) {
          return direction === 'ASC' ? comparison : -comparison;
        }
      }
      return 0;
    });

    for (const index in sortedRows) {
      sortedRows[index].index = Number(index) + 1;
    }
    return sortedRows;
  };

  const sortedRows = useMemo(() => {
    if (!tableData) return [];
    return handleSort(tableData.rows, sortColumns);
  }, [tableData, sortColumns]);

  useEffect(() => {
    setLoading(true);
    if (sortedRows) {
      const initialRows = sortedRows.slice(0, 200); // Load first 50 rows
      setLazyLoadingData(initialRows);
      setHasNext(sortedRows.length > 200); // Check if more rows exist
    }
    setLoading(false);
    setCurrentPage(1);
  }, [sortedRows, groupBy]);

  function loadMoreRows() {
    return new Promise(resolve => {
      const startIndex = currentPage * 200;
      const endIndex = Math.min(startIndex + 200, sortedRows.length); // Avoid out-of-bound slicing
      const newRows = sortedRows.slice(startIndex, endIndex);

      setTimeout(() => resolve(newRows), 0); // Simulate delay
    });
  }

  async function handleScroll(event) {
    if (loading || !hasNext) return;

    setLoading(true);
    const newRows = await loadMoreRows();
    setLazyLoadingData(prevRows => [...prevRows, ...newRows]);
    setCurrentPage(prevPage => prevPage + 1);
    setHasNext(currentPage * 200 + 200 < sortedRows.length); // Update hasNext
    setLoading(false);
  }

  const rowGrouper = (rows, columnKey) => {
    const groupedRows = rows.reduce((acc, row) => {
      const groupKey = row[columnKey];
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(row);
      return acc;
    }, {});
    return groupedRows;
  };
  //   const groupRows = (data, keys) => {
  //     const groupedRowsToExport = rowGrouper(data, keys[0]);
  //     const newKeys = [...keys];
  //     newKeys.shift();
  //     if (newKeys.length > 0) {
  //       const groupedRowsKeys = Object.keys(groupedRowsToExport);

  //       for (const key of groupedRowsKeys) {
  //         groupedRowsToExport[key] = groupRows(
  //           groupedRowsToExport[key],
  //           newKeys
  //         );
  //       }
  //     }
  //     return groupedRowsToExport;
  //   };

  //   const generateGroupedResult = (
  //     data,
  //     columnKey,
  //     headerKeys,
  //     specialColumns
  //   ) => {
  //     let generatedRows = [];
  //     const keys = Object.keys(data);
  //     const rowStartColumnIndex = headerKeys.findIndex(k => k == columnKey);
  //     for (const key of keys) {
  //       let rows = [];
  //       if (Array.isArray(data[key])) {
  //         for (const row of data[key]) {
  //           const r = [];
  //           for (const index in headerKeys) {
  //             if (index > rowStartColumnIndex) {
  //               if (
  //                 specialColumns?.changeToValue?.includes(headerKeys[index])
  //               ) {
  //                 r.push(row[headerKeys[index] + 'Value']);
  //               } else {
  //                 r.push(row[headerKeys[index]]);
  //               }
  //             } else {
  //               r.push('');
  //             }
  //           }
  //           rows.push(r);
  //         }
  //         const h = [];
  //         for (const index in headerKeys) {
  //           if (index > rowStartColumnIndex) {
  //             if (specialColumns?.total?.includes(headerKeys[index])) {
  //               h.push(
  //                 data[key].reduce(
  //                   (acc, num) =>
  //                     acc +
  //                     ((specialColumns?.changeToValue?.includes(
  //                       headerKeys[index]
  //                     )
  //                       ? num[headerKeys[index] + 'Value']
  //                       : num[headerKeys[index]]) || 0),
  //                   0
  //                 )
  //               );
  //             } else {
  //               h.push('');
  //             }
  //           } else if (index == rowStartColumnIndex) {
  //             h.push(key);
  //           } else {
  //             h.push('');
  //           }
  //         }
  //         rows = [h, ...rows];
  //         generatedRows = [...generatedRows, ...rows];
  //       } else {
  //         const rows = generateGroupedResult(
  //           data[key],
  //           headerKeys[rowStartColumnIndex + 1],
  //           headerKeys,
  //           specialColumns
  //         );
  //         const h = [];
  //         for (const index in headerKeys) {
  //           if (index > rowStartColumnIndex) {
  //             if (specialColumns?.total?.includes(headerKeys[index])) {
  //               h.push(
  //                 rows.reduce((acc, row) => {
  //                   if (row[rowStartColumnIndex + 1]) {
  //                     return acc + (row[index] || 0);
  //                   } else return acc;
  //                 }, 0)
  //               );
  //             } else {
  //               h.push('');
  //             }
  //           } else if (index == rowStartColumnIndex) {
  //             h.push(key);
  //           } else {
  //             h.push('');
  //           }
  //         }
  //         generatedRows.push(h);
  //         generatedRows = [...generatedRows, ...rows];
  //       }
  //     }
  //     return generatedRows;
  //   };

  //   if (groupBy && groupBy?.length > 0) {
  //     const data = groupRows(sortedRows, groupBy);
  //     const headerKeys = [...groupBy];
  //     const specialColumns = { total: [], changeToValue: [] };
  //     const columns = tableData?.columns?.filter(col => col.active);
  //     for (const col of columns) {
  //       if (!headerKeys.includes(col.key)) {
  //         headerKeys.push(col.key);
  //         if (col.total) {
  //           specialColumns.total.push(col.key);
  //         }
  //         if (col.type == 'currency' || col.type == 'percent') {
  //           specialColumns.changeToValue.push(col.key);
  //         }
  //       }
  //     }
  //     const body = generateGroupedResult(
  //       data,
  //       headerKeys[0],
  //       headerKeys,
  //       specialColumns
  //     );
  //     const head = Array(
  //       headerKeys.map(
  //         (key, index) =>
  //           tableData?.columns?.find(col => col.key == key)?.name
  //       )
  //     );
  //     const footer = { [headerKeys[0]]: 'total' };
  //     for (const row of sortedRows) {
  //       for (const col of specialColumns.total) {
  //         footer[col] =
  //           (footer[col] || 0) +
  //           (specialColumns?.changeToValue.includes(col)
  //             ? row[col + 'Value']
  //             : row[col]);
  //       }
  //     }
  //     const foot = Array(headerKeys.map((col, index) => footer[col] || ''));

  //     return { head, body, foot };
  //   } else {
  //     let body = [];
  //     let head = [];
  //     // TODO: remove total
  //     let footer = { description: 'total' };
  //     const columns = tableData?.columns?.filter(col => col.active);
  //     for (const row of sortedRows) {
  //       let r = [];
  //       head = [];
  //       for (const col of columns) {
  //         if (col?.children) {
  //           for (const child of col?.children) {
  //             r = [
  //               ...r,
  //               child.type == 'currency' || child.type == 'percent'
  //                 ? row[child?.key + 'Value']
  //                 : row[child.key]
  //             ];
  //             head = [...head, child.name];
  //           }
  //         } else {
  //           r = [
  //             ...r,
  //             col.type == 'currency' || col.type == 'percent'
  //               ? row[col?.key + 'Value']
  //               : row[col.key]
  //           ];
  //           head = [...head, col.name];
  //           if (col.total && col.type != 'text') {
  //             if (footer?.[col.key]) {
  //               footer = {
  //                 ...footer,
  //                 [col.key]:
  //                   footer[col.key] +
  //                   (col.type == 'currency' || col.type == 'percent'
  //                     ? row[col?.key + 'Value'] || 0
  //                     : row[col.key] || 0)
  //               };
  //             } else {
  //               footer = {
  //                 ...footer,
  //                 [col.key]:
  //                   col.type == 'currency' || col.type == 'percent'
  //                     ? row[col?.key + 'Value'] || 0
  //                     : row[col.key] || 0
  //               };
  //             }
  //           }
  //         }
  //       }
  //       body = [...body, r];
  //     }
  //     head = Array(head);
  //     let foot = [];
  //     for (const col of columns) {
  //       if (col.total || footer[col?.key]) {
  //         foot.push(footer[col?.key]);
  //       } else {
  //         foot.push('');
  //       }
  //     }
  //     foot = Array(foot);
  //     return { head, body, foot };
  //   }
  // };

  // function handleExportToCsv() {
  //   flushSync(() => {
  //     setIsExporting(true);
  //   });

  //   const exportData = createExportData();
  //   exportToCsv(exportData, 'report.csv');
  //   flushSync(() => {
  //     setIsExporting(false);
  //   });
  // }

  // async function handleExportToPdf() {
  //   flushSync(() => {
  //     setIsExporting(true);
  //   });

  //   const exportData = createExportData();

  //   await exportToPdf(exportData, 'report.pdf');

  //   flushSync(() => {
  //     setIsExporting(false);
  //   });
  // }

  // const GroupColumnCheckBox = ({ column }) => (
  //   <>
  //     {column?.children?.map(col => (
  //       <Form.Check
  //         type="checkbox"
  //         id={col.key}
  //         label={column.name + ' ' + col.name}
  //         className="text-white"
  //         checked={col.active}
  //         onChange={e =>
  //           setTableData({
  //             ...tableData,
  //             columns: tableData?.columns?.map(c =>
  //               column.key == c.key
  //                 ? {
  //                   ...column,
  //                   children: column.children?.map(c_child =>
  //                     c_child?.key == col.key
  //                       ? { ...c_child, active: e.target.checked }
  //                       : c_child
  //                   )
  //                 }
  //                 : c
  //             )
  //           })
  //         }
  //       />
  //     ))}
  //   </>
  // );

  const Total = () => {
    const columns = tableData?.columns?.filter(
      col => col.active && col.total
    );
    let totals = Object.fromEntries(columns.map(key => [key.key, 0]));
    for (const row of sortedRows) {
      for (const key in totals) {
        let value = totals[key];
        if (row[key + 'Value'] !== undefined) {
          value += Number(row[key + 'Value']);
        } else {
          value += Number(row[key]);
        }

        totals = { ...totals, [key]: value };
      }
    }
    return (
      <Row>
        {columns.map(col => (
          <Col lg={4} sm={6}>
            <p>
              {/* TODO: remove total */}
              Total {col.name}:{' '}
              {col.type === 'currency' && (
                <DefaultCurrency value={totals[col.key]} />
              )}
              {col.type === 'percent' && (
                <PercentFormat value={totals[col.key]} />
              )}
              {col.type === 'number' && totals[col.key]}
            </p>
          </Col>
        ))}
      </Row>
    );
  };
  return (
    <Container style={{ height: '60vh' }} fluid className="pv-4 mb-4">
      {tableData && (
        <>
          <div className="mb-2">
            <div className="d-flex justify-content-end pe-4">
            </div>
            <Row>
              <Col xs={6} lg={4} md={5}>
                <Form>
                  <Form.Label>Group by columns:</Form.Label>
                  <Select
                    isMulti
                    value={tableData?.columns
                      ?.filter(col => groupBy.includes(col.key))
                      .map(col => ({ value: col.key, label: col.name }))}
                    onChange={selectedOptions => {
                      const selectedKeys = selectedOptions.map(
                        option => option.value
                      );
                      setGroupBy(selectedKeys);
                      setExpandedGroupIds(new Set()); // Reset expanded groups
                    }}
                    options={tableData?.columns
                      ?.filter(col => col.groupable && col.active)
                      .map(col => ({ value: col.key, label: col.name }))}
                    // TODO: translate
                    placeholder="Select columns to group by"
                  />
                </Form>
              </Col>
              <Col
                xs={6}
                lg={4}
                md={5}
              >
                <Form.Group>
                  <Form.Label>Search:</Form.Label>
                  <Form.Control
                    type='text'
                    placeholder='Search...'
                    value={filters?.search}
                    onChange={e => setFilters({...filters, search: e.target.value})}

                  />
                </Form.Group>
              </Col>
            </Row>
            { AdditionalFilter && 
              <AdditionalFilter />
            }
          </div>

          <TreeDataGrid
            // ref={gridRef}
            className="rdg-light"
            style={{ height: '85%' }}
            columns={tableData.columns?.filter(col => col.active)}
            rows={groupBy?.length > 0 ? sortedRows : lazyLoadingData}
            groupBy={groupBy}
            direction="ltr"
            rowGrouper={rowGrouper}
            enableVirtualization={!isExporting}
            expandedGroupIds={expandedGroupIds}
            onExpandedGroupIdsChange={ids =>
              setExpandedGroupIds(new Set(ids))
            }
            sortColumns={sortColumns}
            onScroll={handleScroll}
            onSortColumnsChange={setSortColumns}
            defaultColumnOptions={{
              resizable: true,
              sortable: true
              // draggable: true,
            }}
          />
          <div className="pb-4 mb-4 mt-4 ms-4 ps-4">
            <Total />
          </div>
        </>
      )}
    </Container>
  );
};

export default AdvancedTable;
